import { render, staticRenderFns } from "./AddNewModal.vue?vue&type=template&id=04b8931a&scoped=true"
import script from "./AddNewModal.vue?vue&type=script&lang=js"
export * from "./AddNewModal.vue?vue&type=script&lang=js"
import style0 from "./AddNewModal.vue?vue&type=style&index=0&id=04b8931a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b8931a",
  null
  
)

export default component.exports